/**
 * Validates employee information form fields
 * @param {Object} formData - The form data object
 * @returns {Object} - Object containing field errors
 */
export const validateEmployeeInfo = (formData) => {
  const errors = {};

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const mobileRegex = /^(\+\d{1,3}[- ]?)?\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;

  if (!formData.firstName) {
    errors.firstName = "First Name is required";
  } else if (formData.firstName.length < 2) {
    errors.firstName = "First Name must be at least 2 characters";
  }

  if (formData.emailAddress && !emailRegex.test(formData.emailAddress)) {
    errors.emailAddress = "Please enter a valid email address";
  }

  // if (!formData.mobileNumber) {
  //   errors.mobileNumber = "Mobile Number is required";
  // } else if (!mobileRegex.test(formData.mobileNumber)) {
  //   errors.mobileNumber =
  //     "Please enter a valid mobile number (e.g., +1-234-567-8901)";
  // }

  if (!formData.employeeCode) {
    errors.employeeCode = "Username is required";
  } else if (formData.employeeCode.length > 8) {
    errors.employeeCode = "Username cannot be more than 8 characters";
  }

  if (!formData.role) {
    errors.designation = "Please select a role";
  }

  return errors;
};

/**
 * Validates access settings form fields
 * @param {Object} formData - The form data object
 * @returns {Object} - Object containing field errors
 */
export const validateAccessSettings = (formData) => {
  const errors = {};

  // Password validation regex (8+ chars, uppercase, lowercase, number, special char)
  // const passwordRegex =
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // min 8 characters
  const passwordRegex = /^.{8,}$/;

  if (!formData.password) {
    errors.password = "Password is required";
  } else if (!passwordRegex.test(formData.password)) {
    // errors.password =
    //   "Password must be at least 8 characters with uppercase, lowercase, number, and special character";
    errors.password = "Password must be at least 8 characters";
  }

  if (!formData.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};

/**
 * Validates device assignment form fields
 * @param {Object} formData - The form data object
 * @returns {Object} - Object containing field errors
 */
export const validateDeviceAssignment = (formData) => {
  const errors = {};

  if (!formData.device) {
    errors.device = "Please select a device";
  }

  return errors;
};
